import { Voice, body, transient, vary } from '../audio-engine';
export { alarm, beam, boom, dash, hurt, level, missile, portal, preEvo, revive, slash } from './thud';
/* ============================================================
   配方：硬質點擊 SNAP ← **使用者 2026-08-06 選定，預設**
   ============================================================

   跟 `crisp` 同樣住在中頻、同樣不用音階，差別在**打擊的硬度**：

   | | `crisp` 乾淨脆響 | `snap` 硬質點擊 |
   |---|---|---|
   | 主要成分 | 振盪器（純音的「點」） | 濾波雜訊（有顆粒的「啪」） |
   | 命中 | 8 ms 的 760 Hz 點 | 5 ms 的窄帶雜訊，**完全沒有本體** |
   | 讀起來像 | 乾淨的電子回饋 | 薄金屬板、扣板機的機械聲 |

   為什麼雜訊在這裡不會重蹈初版「很躁」的覆轍：初版的白噪是
   **寬頻且落在 2–5 kHz**，這一版是 **Q 值 2.5–3.5 的窄帶、中心 1.1–1.8 kHz**
   —— 窄帶雜訊聽起來是「一個有質地的點」，寬頻才是「嘶」。

   其餘十一個音沿用 `thud`，理由同 `crisp`：A/B 只該有一個變因。 */

/** 主砲：窄帶的「喀」＋很短的中頻支撐。比 `crisp` 多一分機械顆粒。 */
export function shoot(v: Voice) {
  transient({
    bus: 'weapon', x: v.x, z: v.z, vol: 0.8, type: 'bandpass', q: 2.6,
    dur: vary(0.006, 0.2), f0: vary(1900, 0.10), f1: vary(1150, 0.10)
  });
  body({ bus: 'weapon', x: v.x, z: v.z, vol: 0.42, dur: vary(0.022, 0.15), f0: vary(500, 0.08), f1: 360, type: 'triangle' });
}

/** 命中：**只有一顆窄帶雜訊，沒有本體**。全套最短的一個音（5 ms）。

    一秒響幾十次的東西，最好的形狀就是「一個點」——
    有本體就有尾巴，有尾巴就會疊。 */
export function hit(v: Voice) {
  var im = v.imp ? 1 : 0;
  transient({
    bus: 'enemy', x: v.x, z: v.z, vol: 0.42 + im * 0.22, type: 'bandpass', q: 3.2 - im * 0.6,
    dur: vary(0.005 + im * 0.004, 0.22), f0: vary(1750 + im * 250, 0.10), f1: vary(1100, 0.10)
  });
}

/** 擊殺：兩顆窄帶點（錯開 14 ms）＋一段很短的下墜。

    兩顆是刻意的 —— 單顆讀成「命中」，兩顆才讀成「碎掉」。
    `v.n` 越大第二顆越明顯、下墜越短（爆量時節奏要快）。 */
export function kill(v: Voice) {
  var n = Math.max(1, v.n || 1);
  var k = Math.min(1, (n - 1) / 6);
  var im = v.imp ? 1 : 0;
  transient({
    bus: 'enemy', x: v.x, z: v.z, vol: 0.72 + im * 0.12, type: 'bandpass', q: 2.2 - k * 0.5,
    dur: vary(0.008, 0.2), f0: vary(1450 + k * 300, 0.12), f1: vary(820, 0.12)
  });
  body({
    bus: 'enemy', x: v.x, z: v.z, vol: 0.7, dur: vary(0.055 - k * 0.012 + im * 0.035, 0.12),
    f0: vary(380, 0.10), f1: 175, type: 'triangle', drop: 0.3
  });
  setTimeout(function () {
    transient({
      bus: 'enemy', x: v.x, z: v.z, vol: 0.3 + k * 0.3, type: 'bandpass', q: 3.0,
      dur: 0.006, f0: vary(1250, 0.15), f1: 780
    });
  }, 14);
}
